import strapy from "../../assets/project__snaps/strapy.png";
import netflix from "../../assets/project__snaps/netflix-clone.png";
import amazon from "../../assets/project__snaps/amazon.png";
import airbnb from "../../assets/project__snaps/airbnb.png";
import chatroom from "../../assets/project__snaps/chatroom.png";
import portfolio from "../../assets/project__snaps/portfolio.png";

export const projects = [
  {
    img: strapy,
    name: "Strapy",
    desc: "An minimal instagram with simple asthetics and functions.",
    tech: ["React", "Firebase", "Netlify"],
    code: "https://github.com/partharoyy/strapy",
    demo: "https://strapy.netlify.app/",
  },

  {
    img: netflix,
    name: "Netflix clone",
    desc: "A Netflix-clone focused on getting the exact look and feel.",
    tech: ["React", "Tailwind", "Firebase", "Netlify"],
    code: "https://github.com/partharoyy/Netflix-clone",
    demo: "https://netflix-clony.netlify.app/",
  },

  {
    img: amazon,
    name: "Amazon clone",
    desc: "An Amazon clone using firebase functions and stripe payment integration.",
    tech: ["React", "Firebase", "Vercel"],
    code: "https://github.com/partharoyy/Amazon-clone",
    demo: "https://amazon-clone-2hymmwjjl-partharoyy.vercel.app/",
  },

  {
    img: airbnb,
    name: "Airbnb clone",
    desc: "An Airbnb clone focused on the UI integrated with Mapbox.",
    tech: ["React", "Next", "Tailwind", "Vercel"],
    code: "https://github.com/partharoyy/Airbnb-clone",
    demo: "https://airbnb-clone-9j6ialzax-partharoyy.vercel.app/",
  },

  {
    img: chatroom,
    name: "Chat room",
    desc: "Inspired from whatsapp web this is a general chat room.",
    tech: ["React", "Firebase", "Vercel"],
    code: "https://github.com/partharoyy/whatsapp-clone",
    demo: "https://whatsapp-clone-opal.vercel.app/",
  },

  {
    img: portfolio,
    name: "Portfolio",
    desc: "My digital resume.",
    tech: ["React", "Context API", "Netlify"],
    code: "https://github.com/partharoyy/partha-roy",
    demo: "https://partharoy.me/",
  },
];
